<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const rows = computed(() =>
  props.modelValue.map((variable, index) => ({ ...variable, key: index }))
);

const update = (key, field, value) => {
  const next = props.modelValue.map((variable, index) =>
    index === key ? { ...variable, [field]: value } : variable
  );
  emit('update:modelValue', next);
};

const addRow = () => {
  emit('update:modelValue', [...props.modelValue, { field: '', prompt: '' }]);
};

const removeRow = key => {
  emit(
    'update:modelValue',
    props.modelValue.filter((_variable, index) => index !== key)
  );
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-sm font-medium text-n-slate-12">
      {{ $t('AI_AGENT.API_RULES.FORM.COLLECT_VARIABLES.LABEL') }}
    </span>
    <p class="text-xs text-n-slate-10">
      {{ $t('AI_AGENT.API_RULES.FORM.COLLECT_VARIABLES.HELP') }}
    </p>
    <div
      v-for="row in rows"
      :key="row.key"
      class="flex items-start gap-2"
      :data-testid="`collect-variable-row-${row.key}`"
    >
      <Input
        :model-value="row.field"
        :placeholder="$t('AI_AGENT.API_RULES.FORM.COLLECT_VARIABLES.FIELD')"
        class="flex-1"
        @update:model-value="update(row.key, 'field', $event)"
      />
      <Input
        :model-value="row.prompt"
        :placeholder="$t('AI_AGENT.API_RULES.FORM.COLLECT_VARIABLES.PROMPT')"
        class="flex-[2]"
        @update:model-value="update(row.key, 'prompt', $event)"
      />
      <Button
        icon="i-woot-bin"
        slate
        sm
        class="hover:enabled:text-n-ruby-11 hover:enabled:bg-n-ruby-2"
        @click="removeRow(row.key)"
      />
    </div>
    <div>
      <Button
        icon="i-lucide-plus"
        faded
        slate
        sm
        :label="t('AI_AGENT.API_RULES.FORM.COLLECT_VARIABLES.ADD')"
        @click="addRow"
      />
    </div>
  </div>
</template>
